class ClientLogger {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
  }

  async log(level, message, metadata = null) {
    const logEntry = {
      timestamp: new Date().toISOString(),
      level,
      message: message || 'No message provided',
      metadata: metadata || {},
    };

    try {
      if (!this.apiUrl) {
        if (level === 'error') console.error('ClientLogger:', logEntry);
        else console.log('ClientLogger:', logEntry);
        return;
      }

      const res = await fetch(`${this.apiUrl}/api/logs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(logEntry),
      });
      if (!res.ok && level === 'error') {
        console.error('ClientLogger failed to send log', res.status, res.statusText);
      }
    } catch (err) {
      console.error('ClientLogger send error', err);
    }
  }

  info(msg, meta) {
    return this.log('info', msg, meta);
  }
  warn(msg, meta) {
    return this.log('warn', msg, meta);
  }
  error(msg, meta) {
    const details = meta && typeof meta === 'object' ? { ...meta } : {};
    if (msg instanceof Error) {
      details.stack = msg.stack;
      return this.log('error', msg.message, details);
    }
    return this.log('error', msg, details);
  }
}

const clientLogger = new ClientLogger(process.env.REACT_APP_BACKEND_URL);

export default clientLogger;
